export default {
  aggregates: {
    aggregated: 'Resultados agregados',
    aggregatedDate: '{startDate} - {fromDate}',
    ago: 'hace',
    from: 'de',
    since: 'desde',
    unit: {
      DAY: 'día | días',
      MONTH: 'mes | meses',
      YEAR: 'año | años'
    },
    untilNow: 'hasta ahora'
  },
  categoryDetails: {
    average: 'Promedio',
    chartLabel: {
      noLabel: 'No',
      yesLabel: 'Sí'
    },
    description:
      'Esto muestra cómo se distribuyen las respuestas del equipo a todas las preguntas en la categoría.',
    hideOwnAnswers: 'Ocultar las propias respuestas',
    noResponses: 'No hay respuestas',
    notParticipating: 'Tú mismo/a no has respondido a estas preguntas.',
    numberOfPeople: 'Encuestados',
    sensitiveQuestion: 'Únicamente visible para ti como gestor.',
    showFollowUpQuestions: 'Mostrar preguntas de seguimiento',
    toggleButton: {
      overview: 'Resumen',
      questions: 'Preguntas'
    },
    tooltip: {
      barValue: 'nadie | {count} persona | {count} personas',
      barValueAnswers: 'nadie | {count} respuesta | {count} respuestas'
    },
    workWith: 'Cómo trabajar con {categoryName}',
    yourResponse: 'Tú has respondido:'
  },
  error: {
    couldNotLoadAggregates: 'No se han podido cargar los resultados agregados.',
    couldNotLoadResults: 'No se han podido cargar los resultados.',
    networkError:
      'Hubo un problema al cargar los datos de Internet. ¿Tienes una conexión que funcione?',
    unknown: 'Hay un error desconocido'
  },
  errors: {
    status: {
      BadRequest: 'Solicitud incorrecta al servidor',
      Forbidden: 'No se permite el acceso a este recurso',
      InternalServerError:
        'Ha ocurrido un error en el servidor. Si el problema persiste, póngase en contacto con el servicio de asistencia técnica.',
      NotFound: 'No se ha encontrado lo que busca',
      Unauthorized: 'No tiene autorización para acceder a este recurso',
      UnknownError: 'Se ha producido un error desconocido'
    }
  },
  freetext: {
    loadResponses: 'Cargar respuestas',
    noFreeTextQuestions:
      'Si la encuesta contiene preguntas de respuesta libre, podrá ver aquí todas las respuestas.',
    notEnoughResponses: 'No hay suficientes respuestas.',
    responses: 'Sin respuestas|{count} respuesta | {count} respuestas'
  },
  general: {
    add: 'Añadir',
    cancel: 'Cancelar',
    entireOrganization: 'Toda la organización',
    ok: 'Aceptar'
  },
  groupsComparison: {
    averageForItem:
      '{value} es el valor medio para preguntas de {title}. {compareToBenchmark}',
    currentValue: 'Valor actual',
    filter: {
      findGroups: 'Buscar grupos',
      shouldExportWithHierarchy: 'Incluir grupos subyacentes'
    },
    loadMore: 'Cargar más',
    loadMoreInGroup: 'Cargar más en {groupName}',
    noone: 'Nadie ha respondido',
    noResults:
      'Todavía no hay suficientes respuestas para este grupo. {numberOfUsersThatHaveRespondedText}.',
    noResultsResponded: 'han respondido',
    nps: 'Net Promoter Score',
    nps_detractors: 'Detractores',
    nps_passives: 'Pasivos',
    nps_promoters: 'Impulsores',
    questions: 'Preguntas en la categoría',
    showTrend: 'Mostrar cambios',
    violationsIn:
      'Se ha informado de que se han producido infracciones en {groupName}. Ponte en contacto con el departamento de RR. HH., que podrá informarte mejor y ayudarte a solucionar el problema.'
  },
  history: {
    selectorDescriptions: {
      noCustomDateSelected: 'Seleccione una fecha como inicio del historial.',
      selectDate: 'Mostrará el historial de encuestas desde el {date}.',
      selectedDate: 'Mostrando historial de encuestas desde el {date}.'
    },
    selectorOptions: {
      custom: 'personalizado',
      oneMonth: '1 m',
      oneYear: '12 m',
      sixMonths: '6 m'
    }
  },
  loading: {
    error: {
      link: 'Inténtalo de nuevo'
    }
  },
  navbar: {
    administration: 'Administrador/a',
    currentSurveys: 'Encuestas actuales',
    help: 'Ayuda',
    myActivities: 'Acciones',
    ourResults: 'Resultados',
    overview: 'Visión general',
    team: 'Equipo',
    welcome: 'Bienvenido'
  },
  page: {
    results: 'Todos los resultados'
  },
  resultDetails: {
    backToResults: 'Volver',
    exportData: 'Exportar',
    exportModal: {
      includeSensitiveQuestions: 'Incluir preguntas delicadas',
      loadingMessage:
        'Preparando los datos para la exportación, ¡espera un momento!',
      saveAsExcelAllGroupsDescription:
        'Al exportar a Excel obtendrá un archivo con los resultados de {groupTitle} y todos los grupos subyacentes. Esto es útil si desea realizar sus propios análisis o cálculos de varios grupos.',
      saveAsExcelButton: 'Excel',
      saveAsExcelDescription:
        'Al exportar a Excel obtendrá un archivo con los resultados de {groupTitle}{segmentInfo}. Esto es útil si desea realizar sus propios análisis o cálculos.',
      saveAsPdfButton: 'PDF',
      saveAsPdfDescription:
        'Obtendrá un documento PDF con los resultados de todas las categorías y preguntas del grupo seleccionado. Resulta muy útil para imprimir los resultados.',
      saveAsPowerPointButton: 'PowerPoint',
      saveAsPowerPointDescription:
        'La exportación a PowerPoint le proporcionará una práctica presentación con los resultados de {groupTitle}{segmentInfo}. Ideal para mostrar los resultados a otras personas en una pantalla grande.'
    },
    notes: {
      draggable: {
        explanation: 'Sólo visible para ti',
        placeholder:
          'Escribe aquí tus propias notas, comentarios y reflexiones sobre la encuesta.',
        title: 'Notas personales'
      },
      status: {
        initial: 'Se guarda de forma automática a medida que escribes',
        saved: '¡Cambios guardados!',
        unsaved: 'Guardando pronto...'
      }
    },
    tagDetails: {
      color: {
        alerts: {
          notEnoughResponses:
            'No hay suficientes respuestas para mostrar los resultados por usuario.'
        },
        description: {
          high: 'Una persona ha respondido, por lo que su puntuación media se ha puesto en verde.|Han respondido {count} personas, por lo que su puntuación media se ha puesto en verde.',
          low: 'Una persona ha respondido, por lo que su puntuación media se ha puesto en rojo.|Han respondido {count} personas,  por lo que su puntuación media se ha puesto en rojo.',
          medium:
            'Una persona ha respondido, por lo que su puntuación media se ha puesto en amarillo.|Han respondido {count} personas, por lo que su puntuación media se ha puesto en amarillo.'
        },
        title: 'Nadie|Una persona|{count} personas'
      },
      currentValue: {
        equalsToBenchmarkValue:
          'Tu puntuación es la misma que la del Pulsᐩ benchmark® para {title}.',
        higherThanBenchmarkValue:
          'Tu puntuación es {benchmarkDiff} más alta que el Pulsᐩ benchmark® para {title}, que es {benchmarkValue}. ¡Bien!',
        lowerThanBenchmarkValue:
          'Estás {benchmarkDiff} por debajo del Pulsᐩ benchmark® para {title} que es {benchmarkValue}',
        percentagePoints: 'Puntos de porcentaje'
      },
      enps: {
        button: {
          description:
            'Se remitirá a nuestro socio, EQI, que recopila datos de evaluación comparativa de un gran número de organizaciones y proporciona información más detallada sobre tu propia puntuación eNPS.',
          title: 'Compara tu puntuación eNPS con la de otras organizaciones'
        }
      },
      toggleButton: {
        history: 'Historial',
        overview: 'Visión general'
      }
    }
  },
  results: {
    aggregated: 'Agregado',
    chooseSurvey: 'Elegir encuesta',
    finished: 'Terminada',
    published: 'En curso'
  },
  resultsmessages: {
    disclaimer: 'Pulsᐩ AI utiliza IA generativa y puede cometer errores.',
    error: {
      generic:
        'Algo no funciona como es debido. Intente volver a cargar la página.',
      notEnoughResults:
        'Ningún resultado sobre el que comentar. Seleccione otro grupo o encuesta para utilizar IA Pulsᐩ.'
    },
    moreInfo: 'Descubra cómo utilizar Pulsᐩ AI como líder',
    moreInfoLink: 'https://www.puls-solutions.com/help/#/section/1/articles/10',
    placeholder: 'Haga una pregunta sobre los resultados...',
    reload: 'Volver a cargar la página',
    report: 'Informar de un problema',
    send: 'Enviar',
    suggestionHeader:
      'Estas son algunas sugerencias de preguntas que puede formular:',
    suggestions: {
      groupsComparison: {
        1: '¿En qué grupos debo concentrarme?',
        2: '¿Hay alguna pregunta en la que la mayoría de los grupos deberían trabajar?',
        3: '¿Qué grupos muestran tendencias negativas?',
        4: '¿Qué grupos tienen tendencias positivas?',
        5: '¿Qué grupos se destacan negativamente?',
        6: '¿Qué grupos necesitan mi atención?',
        7: '¿Qué debo hacer primero?'
      },
      overview: {
        1: '¿Qué debo hacer con nuestro resultado?',
        2: '¿Cómo debería presentar el resultado a mi equipo?',
        3: 'En general, ¿cómo se muestran los resultados?',
        4: '¿Cuáles son las 3 principales medidas que debemos tomar?',
        5: '¿Qué puedo mejorar en mi liderazgo?',
        6: '¿Cuáles son los riesgos que tenemos?',
        7: '¿Qué podría suceder si no respondemos?',
        8: '¿Qué debería priorizar?',
        9: '¿Cuál es el pronóstico para mi equipo?'
      }
    },
    title: 'IA Pulsᐩ'
  },
  resultsPerAttribute: {
    attributes: {
      all: {
        title: 'Todo el mundo'
      }
    }
  },
  sections: {
    resultsForSurvey: {
      tabs: {
        compare: {
          title: 'Comparar'
        },
        export: {
          title: 'Exportar'
        },
        freetext: {
          title: 'Respuesta libre'
        },
        results: {
          title: 'Resultados de la encuesta'
        }
      }
    }
  },
  segmentedDetails: {
    notEnoughResponses:
      'No es posible mostrar estadísticas sin arriesgarse a perder el anonimato.',
    others: 'Otro | Otros',
    tooltip: {
      barValue: '{numberOfPeople} {segment}'
    }
  },
  sidebar: {
    administration: 'Administración',
    currentSurveys: 'Encuestas en curso',
    dashboard: 'Panel de control',
    help: 'Ayuda',
    logOut: 'Cerrar sesión',
    myActivities: 'Mis acciones',
    ourResults: 'Nuestros resultados'
  },
  topbanner: {
    preview: {
      body: 'La nueva versión de la vista de resultados Pulsᐩ incluye numerosas mejoras. Si algo no funciona como debería o tiene algún comentario, no dude en comunicárnoslo. También es posible volver a la versión anterior si se desea.',
      header: '¡Nueva versión!'
    }
  },
  trendArrow: {
    category: {
      tooltip: {
        trend_decreased:
          'Durante el período de tiempo de {startDate} a {endDate}, el resultado de {categoryName} disminuyó.',
        trend_increased:
          'Durante el período de tiempo de {startDate} a {endDate}, el resultado ha aumentado para {categoryName}. ¡Sigan con el buen trabajo!',
        trend_same:
          'El resultado sigue siendo el mismo para {categoryName} durante el período de tiempo de {startDate} a {endDate}.'
      }
    },
    noTrend: 'No hay ninguna encuesta más antigua con la que comparar.',
    tag: {
      tooltip: {
        nps_trend_decreased:
          'En comparación con la encuesta anterior realizada el {oldSurveyDate} el resultado ha disminuido en un {changeInPercent} % para {tagName}.',
        nps_trend_increased:
          'En comparación con la encuesta anterior realizada el {oldSurveyDate} el resultado ha aumentado un {changeInPercent} % para {tagName}.',
        nps_trend_same:
          'El resultado se ha mantenido más o menos igual ({cambioEnPorcentaje} % de cambio) para {tagName} desde la última encuesta realizada el {oldSurveyDate}.',
        trend_decreased:
          'Durante el período de tiempo de {startDate} a {endDate}, el resultado de {tagName} disminuyó.',
        trend_increased:
          'Durante el período de tiempo de {startDate} a {endDate}, el resultado ha aumentado para {tagName}',
        trend_same:
          'El resultado sigue siendo el mismo para {categoryName} durante el período de tiempo de {startDate} a {endDate}.'
      }
    }
  },
  utilityBar: {
    allGroups: 'Todos los grupos',
    cannotChangeGroupsWhileComparing:
      'En la vista de comparación se ven varios grupos a la vez.',
    group: 'Grupo',
    segment: 'Segmento',
    survey: 'Encuesta'
  },
  widgetActionsSummary: {
    labels: {
      peopleThatSelectedAnAction:
        'Número de personas que seleccionaron al menos una acción',
      totalActions: 'Número total de acciones seleccionadas'
    },
    title: 'Resumen de acciones'
  },
  widgetAlert: {
    actions: {
      saved: 'Gracias, la actividad se ha guardado.'
    },
    links: {
      tooltip: 'El enlace se abre en una nueva ventana'
    },
    notEnoughData: 'No hay nada que mostrar aquí en este momento.'
  },
  widgetCategoriesBars: {
    aggregateInfo: {
      harassment: {
        info: 'Última notificación {surveyDate}.'
      },
      question: {
        info: 'Pregunta más reciente {surveyDate} en "{surveyTitle}".'
      }
    },
    notEnoughResponses:
      'Todavía no hay suficientes respuestas para mostrar algo aquí.',
    title: 'Categorías',
    tooltip: {
      value:
        'Este es el valor medio de todas las respuestas a las preguntas de {categoryName} contestadas por personas de {groupName}.'
    }
  },
  widgetErrorFallback: {
    description:
      'Se ha producido un error imprevisto al intentar cargar el widget. Primero pruebe a volver a cargar la página. Si el problema persiste, notifíquenoslo y lo revisaremos de inmediato.',
    hideErrorDetails: 'Ocultar detalles del error',
    showErrorDetails: 'Mostrar detalles del error',
    title: 'Problema en el widget.'
  },
  widgetGroupActions: {
    allCategories: 'En todas las categorías',
    freeText: {
      alert: {
        noResults: 'No se ha encontrado nada. Intenta escribir algo más.',
        typeMore: 'Escribe algo más'
      },
      filterField: {
        placeholder: 'Escribe para encontrar comentarios'
      },
      numberOfComments: '{numberOfComments} comentarios'
    },
    links: {
      guide: {
        link: 'https://player.vimeo.com/video/887258169',
        title:
          'Cómo desarrollar la responsabilidad personal entre los empleados'
      }
    },
    noActions: 'No hay acciones que mostrar.',
    noActionsSelectedInCategory: 'No hay acciones seleccionadas',
    otherActions: 'Acciones propias',
    people: 'nadie | {count} persona | {count} personas',
    peopleSelectedActions:
      'De {peopleResponded} personas que respondieron solo 1 ha seleccionado al menos una acción ({percentage}%)| De {peopleResponded} personas que respondieron, {count} personas seleccionaron al menos una acción ({percentage}%)',
    title: 'Acciones elegidas para las personas de {groupName}',
    tooltip: {
      numberOfPeopleChoseActions:
        '1 persona ha seleccionado esta acción| {count} personas seleccionaron esta acción'
    }
  },
  widgetGroupPriorities: {
    description:
      'Según los participantes en la encuesta, estas son las áreas más importantes en las que hay que centrarse ahora mismo.',
    freeTextResponses: 'Mostrar respuestas de texto libre',
    links: {
      guide: {
        link: 'https://player.vimeo.com/video/887214144',
        title: 'Cómo desarrollar tu equipo con Pulsᐩ'
      }
    },
    noPriorities: 'Los participantes no eligen las prioridades.',
    people: 'nadie | {count} persona | {count} personas',
    thinkImportant: ' consideran que "{category}" es lo más importante',
    title: 'Prioridades para las personas de {groupName}'
  },
  widgetNotImplemented: {
    content: 'Aún no se ha aplicado'
  },
  widgetSurveyInfo: {
    endDate: 'Fecha de finalización:',
    noone: 'Nadie ha respondido',
    notEnoughResponses: {
      aggregate:
        'No han respondido suficientes personas en el plazo previsto para poder mostrar resultados.',
      completed:
        'No han respondido a la encuesta suficientes personas para poder mostrar resultados.',
      published:
        'Aún no han respondido a la encuesta suficientes personas para poder mostrar resultados.'
    },
    participation: {
      title: 'Participación'
    },
    startDate: 'Fecha de inicio:',
    status: {
      completed:
        'La encuesta se ha completado. Estos son los resultados finales.',
      published: 'La encuesta sigue en curso. Los resultados son preliminares.'
    },
    usersInvited: 'Personas invitadas:',
    usersResponded: 'Personas que han respondido:'
  },
  widgetTagsDonuts: {
    description: {
      all: 'Estos son los resultados más recientes de {groupName}.'
    },
    notEnoughResponses:
      'Todavía no hay suficientes respuestas para mostrar algo aquí.',
    title: {
      company: 'Todo de {organizationName}'
    },
    tooltip: {
      enps_description:
        'eNPS son las siglas en inglés de "Employee Net Promoter Score" y mide la disposición de los empleados a defender el empleo en su empresa.',
      nps_description:
        'NPS significa "Net Promoter Score" y es una medida de la probabilidad de que las personas recomienden algo a otras.',
      nps_detractors: 'Detractores',
      nps_passives: 'Pasivos',
      nps_promoters: 'Impulsores',
      value:
        'Este es el valor medio de todas las respuestas a las preguntas etiquetadas con {tagName} respondidas por personas de {groupName}.'
    }
  },
  widgetTagsTrends: {
    title: '{tagNames} a lo largo del tiempo',
    twoTags: '{tag1} y {tag2}'
  }
}
